import WhatsApp from '../../src/legacy/WhatsApp';
export default WhatsApp;
